module.exports = __webpack_public_path__ + "img/icon-voice-assistant.8af0cb80.svg";